var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('history-filter-link',{attrs:{"filterLayout":_vm.filterLayout}}),_c('history-list-link',{attrs:{"listLayout":_vm.listLayout,"historyData":_vm.List}}),_c('pagination-link',{attrs:{"paginationLayout":_vm.paginationLayout,"type":_vm.historyType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }